/**
 * API 配置
 * 统一管理后端服务地址
 */

export const API_BASE_URL = 'https://lineup.hk';

// 导出用于静态资源的完整 URL 构建函数
export const getStaticResourceUrl = (path: string | undefined, basePath?: string): string => {
  if (!path) return '';
  if (path.startsWith('http')) return path;

  if (basePath) {
    return path.startsWith(basePath)
      ? `${API_BASE_URL}${path}`
      : `${API_BASE_URL}${basePath}${path}`;
  }

  return `${API_BASE_URL}${path}`;
};
